export interface NoveltyCheckReportTitleApiRequest {
    task_id: string;
}

export type NoveltyCheckReportTitleApiResponse = string;

/**
 * 新颖性报告名称 API
 */
export interface NoveltyCheckReportTitleApi {
    /**
     * 获取新颖性报告名称
     * @returns 新颖性报告名称
     */
    getNoveltyCheckReportTitle(data: NoveltyCheckReportTitleApiRequest): Promise<NoveltyCheckReportTitleApiResponse>;
}

export const NoveltyCheckReportTitleApi = Symbol.for('NoveltyCheckReportTitleApi');
